import styled from 'styled-components';

const Container = styled.div``;

const Header = styled.div`
  background-color: var(--surface-2);
  border: 1px solid var(--border);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2.4rem 3rem;
  border-radius: var(--r-md);
  margin-bottom: 2.5rem;

  @media (max-width: 520px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 3rem;

    button {
      width: 100%;
    }
  }
`;

const BalanceContainer = styled.div`
  small {
    font-weight: 500;
  }

  h1 {
    color: var(--primary-color);
    font-size: 4.8rem;
    font-weight: 500;

    @media (max-width: 600px) {
      font-size: 4.2rem;
    }
  }
`;

const Headline = styled.h2`
  margin: 2rem 0;
`;

export { Container, Header, BalanceContainer, Headline };
